<template>
  <div class="dashboard-editor-container">
    <!-- <github-corner style="position: absolute; top: 0px; border: 0; right: 0;"/> -->
    <template v-if="roleId !== 1 && roleId !== 2 && roleId !== 3">
      暂无权限查看此页面内容
    </template>
    <template v-else>
      <div class="fixed" >
        <panel-group :childrenData="childrenData" @handleSetLineChartData="handleSetLineChartData"/>
      </div>
      <div class="right-fixed">
        <div class="title">
          运行设备 acility Operations
        </div>
        <el-scrollbar wrap-class="scrollbar-wrapper" style="height: calc(100% - 24px)">
          <div v-infinite-scroll="getAgentYield" infinite-scroll-distance="0" infinite-scroll-disabled="disabledYeild" class="infinite-list">
            <div v-for="(item,index) in listYield" :key="index" class="infinite-list-item">
              <img src="@/assets/icon-normal.png" alt="">
              <div class="right">
                <p>场地名称：{{ item.fieldName }}</p>
                <div class="desc">
                  设备使用率:
                  <el-progress :percentage="item.dayCount" style="flex:1" color="#1890FF"/>
                </div>
              </div>
              <!-- <el-row type="flex">
                <el-col :span="4" :title="item.fieldName" style="font-size: 14px;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;">
                  {{ item.fieldName }}
                </el-col>
                <el-col :span="16" style="text-align: center">
                  <el-progress :percentage="item.dayCount!==0?Number((item.useRatio/item.dayCount*100).toFixed(2)):0" color="#FF6427"/>
                </el-col>
                <el-col :span="4" style="text-align:center">
                  {{ item.amount + ' 元' }}
                </el-col>
              </el-row> -->
            </div>

          </div>
          <p v-if="loadingYield" style="text-align: center;font-size:14px;">加载中...</p>
          <p v-if="!loadingYield" style="text-align: center;font-size: 14px;">没有更多了</p>
        </el-scrollbar>
      </div>
      <div id="bmap"/>
    </template>

  </div>
</template>

<script>
import BaiduMap from '../../../../static/map'
import moment from 'moment'
import { qryProfit, qryAgentInfo, qryFieldInfo, qryDeviceFlowRecord, qryFieldFlowRecord, homeCount, userGrowth, sumAmount, qryDeviceInstallCount, homeFieldInfo } from '@/api/home'
// import { formatDateTime } from '@/utils'
// import GithubCorner from '@/components/GithubCorner'
import PanelGroup from './components/PanelGroup'
import LineChart from './components/LineChart'
import AllChart from './components/AllChart'
import PhaseEarning from './components/PhaseEarning'
// import RaddarChart from './components/RaddarChart'
// import PieChart from './components/PieChart'
import BarChart from './components/BarChart'
// import TransactionTable from './components/TransactionTable'
// import TodoList from './components/TodoList'
// import BoxCard from './components/BoxCard'
// import axios from 'axios'

// const api = 'https://hn.algolia.com/api/v1/search_by_date?tags=story'

const lineChartData = {
  list: {
    expectedData: [200, 192, 120, 144, 160, 130, 140],
    actualData: [180, 160, 151, 106, 145, 150, 130]
  },
  peoples: {
    actualData: [180, 160, 151, 106, 145, 150, 130]
  },
  money: {
    actualData: [120, 90, 100, 138, 142, 130, 130]
  },
  chartData: {
    actualData: [120, 82, 91, 154, 162, 140, 130]
  }
}
// const allLineChartData = {
//   // expectedData: [200, 192, 120, 144, 160, 130, 140],
//   actualData: [180, 160, 151, 106, 145, 150, 130]
// }
// const allLineChartData = {
// expectedData: [200, 192, 120, 144, 160, 130, 140],
// actualData: [180, 160, 151, 106, 145, 150, 130]
// }

export default {
  name: 'DashboardAdmin',
  components: {
    // GithubCorner,
    PanelGroup,
    LineChart,
    AllChart,
    PhaseEarning,
    // RaddarChart,
    // PieChart,
    BarChart
    // TransactionTable,
    // TodoList,
    // BoxCard
  },
  data() {
    return {
      lineChartData: lineChartData.list,
      activeName: '1',
      allLineChartData: {
        actualData: [],
        addTime: []
      },
      line1: '用户增长曲线',
      phaseEarning: {
        actualData: [],
        addTime: []
      },
      installChartData: {
        actualData: [],
        addTime: []
      },
      fieldQuery: {
        startTime: null,
        endTime: null,
        pageIndex: 1,
        pageSize: 10
      },
      agentQuery: {
        startTime: null,
        endTime: null,
        pageIndex: 1,
        pageSize: 10
      },
      deviceQuery: {
        userId: null,
        startTime: null,
        endTime: null,
        pageIndex: 1,
        pageSize: 10
      },
      fieldRecordQuery: {
        userId: null,
        startTime: null,
        endTime: null,
        pageIndex: 1,
        pageSize: 10
      },
      childrenData: {
        amount: null,
        deviceCount: null,
        fieldCount: null,
        hisAmount: null,
        imeiCount: null,
        thisMonth: null,
        todayAmount: null,
        userCount: null
      },
      value1: [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')],
      value2: [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')],
      value3: [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')],
      value4: [moment().startOf('month').format('YYYY-MM-DD'), moment().endOf('month').format('YYYY-MM-DD')],
      page: 1,
      list: [],
      listYield: [],
      listDevice: [],
      listFieldRecord: [],
      current: 0,
      count: 0,
      loading: false,
      pageCount: 0,
      pageCountYield: 0,
      pageCountDevice: 0,
      pageCountFieldRecord: 0,
      loadingYield: false,
      loadingDevice: false,
      loadingFieldRecord: false,
      fieldTotalMoney: 0,
      agentTotalMoney: 0,
      deviceFlowRecordTotalMoney: 0,
      fieldFlowRecordTotalMoney: 0,
      roleId: null,
      fieldUseDataForm: {
        dateTime: new Date(),
        type: 1
      },
      map: null,
      BMap: null,
      centerMarkers: []
    }
  },
  computed: {
    noMore() {
      return this.fieldQuery.pageIndex > this.pageCount
    },
    disabled() {
      return this.loading || this.noMore
    },
    noMoreYield() {
      return this.agentQuery.pageIndex > this.pageCountYield
    },
    disabledYeild() {
      return this.loadingYield || this.noMoreYield
    },
    noMoreDevice() {
      return this.deviceQuery.pageIndex > this.pageCountDevice
    },
    disabledDevice() {
      return this.loadingDevice || this.noMoreDevice
    },
    noMoreFieldRcord() {
      return this.fieldRecordQuery.pageIndex > this.pageCountFieldRecord
    },
    disabledFieldRecord() {
      return this.loadingFieldRecord || this.noMoreFieldRcord
    }
  },
  watch: {
    'fieldUseDataForm.dateTime': function(value) {
      console.log(value)
      if (this.activeName === '1') {
        this.getFieldUse(1)
      } else {
        this.getFieldUse(2)
      }
    }
  },
  async created() {
    const that = this
    BaiduMap.init().then((BMap) => {
      that.BMap = BMap
      const map = that.map = new BMap.Map('bmap', { enableMapClick: true })
      // map.centerAndZoom('北京', 11)
      // if (this_.detail.FieldInfo.FieldName && this_.detail.FieldInfo.Longitude !== 0 && this_.detail.FieldInfo.Latitude !== 0) {
      //   map.centerAndZoom(new BMap.Point(this_.detail.FieldInfo.Longitude, this_.detail.FieldInfo.Latitude), 11)
      //   marker = new BMap.Marker(new BMap.Point(this_.detail.FieldInfo.Longitude, this_.detail.FieldInfo.Latitude))
      // } else {
      //   map.centerAndZoom('北京', 11)
      //   marker = new BMap.Marker(new BMap.Point(116.403613, 39.91513))
      // }
      // var top_left_navigation = new BMap.NavigationControl() // 左上角，添加默认缩放平移控件
      // this_.ac = new BMap.Autocomplete( // 建立一个自动完成的对象
      //   {
      //     'input': 'suggestId',
      //     'location': map
      //   })
      // var ac = this_.ac
      // map.addControl(top_left_navigation)
      // map.addOverlay(marker)
      map.enableScrollWheelZoom(true)
      // var geoc = new BMap.Geocoder()
      // // 点击自动完成
      // // ac.addEventListener('onconfirm', e => {
      // //   console.log(e)
      // //   this_.Address = this_.detail.FieldInfo.Address = ''
      // //   this_.Address = this_.detail.FieldInfo.Address = e.item.value.province + e.item.value.city + e.item.value.district + e.item.value.street
      // //   this_.Address = this_.detail.FieldInfo.Address = this_.detail.FieldInfo.Address.substr(0, 11)
      // //   geoc.getPoint(this_.detail.FieldInfo.Address, function(e) {
      // //     map.clearOverlays()
      // //     if (!this_.detail.FieldInfo) {
      // //       this_.detail.FieldInfo = {}
      // //     }
      // //     this_.detail.FieldInfo.Longitude = e.lng
      // //     this_.detail.FieldInfo.Latitude = e.lat
      // //     marker = new BMap.Marker(new BMap.Point(this_.detail.FieldInfo.Longitude, this_.detail.FieldInfo.Latitude))
      // //     map.centerAndZoom(this_.detail.FieldInfo.Address, 11)
      // //     map.addOverlay(marker)
      // //   })
      // // })
      // // ac.hide()
      // map.addEventListener('click', (e) => {
      //   map.clearOverlays()
      //   if (!this.detail.FieldInfo) {
      //     this.detail.FieldInfo = {}
      //   }
      //   geoc.getLocation(e.point, (rs) => {
      //     var addComp = rs.addressComponents
      //     this.detail.FieldInfo.Longitude = e.point.lng
      //     this.detail.FieldInfo.Latitude = e.point.lat
      //     this.$set(this.detail.FieldInfo, 'Address', addComp.city + addComp.district + addComp.street + addComp.streetNumber)
      //     // this.detail.FieldInfo.Address = addComp.city + addComp.district + addComp.street + addComp.streetNumber
      //     // this.Address = this.detail.FieldInfo.Address = this.detail.FieldInfo.Address.substr(0, 11)
      //     marker = new BMap.Marker(new BMap.Point(this.detail.FieldInfo.Longitude, this.detail.FieldInfo.Latitude))
      //     map.addOverlay(marker)
      //   })
      // })
    })
    this.roleId = this.$store.getters.roles.RoleId
    this.fieldRecordQuery.userId = this.$store.getters.roles.UserId
    homeCount().then(res => {
      console.log(res, '25411------------')
      this.childrenData = res
    })
    userGrowth({ type: 2 }).then(res => {
      console.log(res)
      res.forEach(item => {
        this.allLineChartData.actualData.push(item.Count)
        const time = new Date(item.Time)
        let year = null
        console.log(time)
        if (time + 1 === 1) {
          year = time.getFullYear()
          this.allLineChartData.addTime.push(year + '年' + time.getMonth() + 1 + '月')
        } else {
          this.allLineChartData.addTime.push(time.getMonth() + 1 + '月')
        }
      })
      sumAmount().then(res => {
        res.forEach(item => {
          this.phaseEarning.actualData.push(item.Amount)
          const time = new Date(item.Time)
          let year = null
          if (time + 1 === 1) {
            year = time.getFullYear()
            this.phaseEarning.addTime.push(year + '年' + time.getMonth() + 1 + '月')
          } else {
            this.phaseEarning.addTime.push(time.getMonth() + 1 + '月')
          }
        })
      })
      qryDeviceInstallCount({ userId: this.$store.getters.roles.UserId }).then(res => {
        res.forEach(item => {
          this.installChartData.actualData.push(item.Count)
          const time = new Date(item.Time)
          let year = null
          if (time + 1 === 1) {
            year = time.getFullYear()
            this.installChartData.addTime.push(year + '年' + time.getMonth() + 1 + '月')
          } else {
            this.installChartData.addTime.push(time.getMonth() + 1 + '月')
          }
        })
      })
      console.log(this.allLineChartData, 267)
      this.getFieldUse(1)
    })
  },
  beforeDestroy() {
    this.allLineChartData.actualData = []
    this.allLineChartData.addTime = []
    this.phaseEarning.actualData = []
    this.phaseEarning.addTime = []
  },
  methods: {
    getList() {
      qryProfit({ userId: this.$store.getters.roles.UserId }).then(res => {
        this.childrenData = res
        console.log(this.childrenData)
      })
    },
    // 获取场地方收益使用率
    getFieldUse(type) {
      homeFieldInfo({ ...this.fieldUseDataForm, type }).then(res => {
        console.log(this.map, '254------------')
        // console.log(res, 345)
        // const marker = new this.BMap.Marker(new this.BMap.Point(this.detail.FieldInfo.Longitude, this.detail.FieldInfo.Latitude))

        res.forEach(item => {
          item.ratio = item.useRatio / item.dayCount
          this.centerMarkers.push({ lng: item.longitude, lat: item.latitude })
          const myIcon = new this.BMap.Icon(require('@/assets/map-use.png'), new this.BMap.Size(28, 39))
          this.map.addOverlay(new this.BMap.Marker(new this.BMap.Point(item.longitude, item.latitude), { icon: myIcon }))
        })
        var view = this.map.getViewport(this.centerMarkers)
        var mapZoom = view.zoom
        var centerPoint = view.center
        console.log(centerPoint, '369---------------')
        // 设初始化地图。
        this.map.centerAndZoom(centerPoint, mapZoom)

        if (this.activeName === '1') {
          res.sort(this.compare('ratio'))
        }
        // console.log(res, '369222---------------')
        this.listYield = res
      })
    },
    // 数组对象排序
    compare(property) {
      return function(a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value2 - value1
      }
    },
    // 场地方收益
    getFieldYield(reset) {
      this.loading = true
      setTimeout(() => {
        qryFieldInfo(this.fieldQuery).then(res => {
          if (reset === 'reset') {
            this.list = res.LsList.LsList
            this.fieldTotalMoney = res.TotalMoney
            this.fieldQuery.pageIndex += 1
            this.pageCount = Math.ceil(res.LsList.TotalRows / this.fieldQuery.pageSize)
            this.loading = false
          } else {
            this.list.push(...res.LsList.LsList)
            this.fieldTotalMoney = res.TotalMoney
            this.fieldQuery.pageIndex += 1
            this.pageCount = Math.ceil(res.LsList.TotalRows / this.fieldQuery.pageSize)
            this.loading = false
          }
        })
      }, 1000)
    },
    handleBlur(type) {
      switch (type) {
        case 'yield':
          this.agentQuery.startTime = this.value2[0]
          this.agentQuery.endTime = this.value2[1]
          this.agentQuery.pageIndex = 1
          this.getAgentYield('reset')
          break
        case 'device':
          this.deviceQuery.startTime = this.value3[0]
          this.deviceQuery.endTime = this.value3[1]
          this.deviceQuery.pageIndex = 1
          this.getDeviceFlowRecord('reset')
          break
        case 'fieldRecord':
          this.fieldRecordQuery.startTime = this.value4[0]
          this.fieldRecordQuery.endTime = this.value4[1]
          this.fieldRecordQuery.pageIndex = 1
          this.getFieldFlowRecord('reset')
          break

        default:
          this.fieldQuery.startTime = this.value1[0]
          this.fieldQuery.endTime = this.value1[1]
          this.fieldQuery.pageIndex = 1
          this.getFieldYield('reset')
          break
      }
    },
    // 代理商收益
    getAgentYield(reset) {
      this.loadingYield = true
      setTimeout(() => {
        qryAgentInfo(this.agentQuery).then(res => {
          if (reset === 'reset') {
            this.listYield = res.LsList.LsList
            this.agentTotalMoney = res.TotalMoney
            this.agentQuery.pageIndex += 1
            this.pageCountYield = Math.ceil(res.LsList.TotalRows / this.agentQuery.pageSize)
            this.loadingYield = false
          } else {
            this.listYield.push(...res.LsList.LsList)
            this.agentTotalMoney = res.TotalMoney
            this.agentQuery.pageIndex += 1
            this.pageCountYield = Math.ceil(res.LsList.TotalRows / this.agentQuery.pageSize)
            this.loadingYield = false
          }
        })
      }, 1000)
    },
    // 获取设备流水记录
    getDeviceFlowRecord(reset) {
      this.loadingDevice = true
      setTimeout(() => {
        qryDeviceFlowRecord(this.deviceQuery).then(res => {
          if (reset === 'reset') {
            this.listDevice = res.LsList.LsList
            this.deviceFlowRecordTotalMoney = res.TotalMoney
            this.deviceQuery.pageIndex += 1
            this.pageCountDevice = Math.ceil(res.LsList.TotalRows / this.deviceQuery.pageSize)
            this.loadingDevice = false
          } else {
            this.deviceQuery.pageIndex += 1
            this.deviceFlowRecordTotalMoney = res.TotalMoney
            this.listDevice.push(...res.LsList.LsList)
            this.pageCountDevice = Math.ceil(res.LsList.TotalRows / this.deviceQuery.pageSize)
            this.loadingDevice = false
          }
        })
      }, 1000)
    },
    // 获取场地流水记录
    getFieldFlowRecord(reset) {
      this.loadingFieldRecord = true
      setTimeout(() => {
        qryFieldFlowRecord(this.fieldRecordQuery).then(res => {
          if (reset === 'reset') {
            this.listFieldRecord = res.LsList.LsList
            this.fieldFlowRecordTotalMoney = res.TotalMoney
            this.fieldRecordQuery.pageIndex += 1
            this.pageCountFieldRecord = Math.ceil(res.LsList.TotalRows / this.fieldRecordQuery.pageSize)
            this.loadingFieldRecord = false
          } else {
            this.listFieldRecord.push(...res.LsList.LsList)
            this.fieldFlowRecordTotalMoney = res.TotalMoney
            this.fieldRecordQuery.pageIndex += 1
            this.pageCountFieldRecord = Math.ceil(res.LsList.TotalRows / this.fieldRecordQuery.pageSize)
            this.loadingFieldRecord = false
          }
        })
      }, 1000)
    },
    // 标签栏切换
    handleClick(tab, event) {
      console.log(tab, event)
      console.log(this.activeName)
      if (this.activeName === '2') {
        this.getFieldUse(2)
      } else {
        this.getFieldUse(1)
      }
    },
    // handleSearch() {
    //   this.phaseEarning.actualData = []
    //   this.phaseEarning.addTime = []
    //   this.getSumAmount()
    // },
    handleSetLineChartData(type) {
      this.lineChartData = lineChartData[type]
    }
  }
}
</script>

<style lang="scss">
ul{
  padding: 0;
  margin: 0;
  li{
    list-style: none;
    padding: 0;
    margin: 0;
  }
}
.el-scrollbar__wrap{
  overflow-x: hidden !important;
}
.el-progress-bar__outer{
  margin-top: 4px;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard-editor-container {
  background-color: rgb(240, 242, 245);
  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}
.container {
  height: 200px;
}
.card-right{
  float: right;
  width: 75%;
  line-height: 36px;
  text-align: right;
}

.box-card{
  .clearfix{
    span{
      line-height: 36px;
    }
    .tag-big{
      line-height: 34px;
      .tag{
        line-height: 28px;
      }
    }

  }
}
.el-progress{
  display: flex;
  margin-left: 10px;
}
.box-card{
  border: none;
}
#bmap{
  width: 100%;
  height: calc(100vh - 88px);
}
.fixed{
  padding: 0 30px;
  width: calc(100% - 180px - 482px);
  position: fixed;
  top: 88px;
  z-index: 99;
}
.right-fixed{
  width: 482px;
  position: fixed;
  z-index: 99;
  right: 0;
  top: 84px;
  background-color: white;
  height: calc(100vh - 84px);
  overflow-x: hidden;
  overflow-y: hidden;
  padding: 20px;
  .title{
    font-size: 20px;
    color: black;
    display: flex;
    align-items: center;
    &::before{
      content: '';
      width: 4px;
      height: 18px;
      background-color: #1890FF;
      border-radius: 5px;
      margin-right: 8px;
    }
  }
}
.infinite-list-item{
  display: flex;
  align-items: center;
  margin-top: 40px;
  img{
    width: 47px;
    height: 47px;
    margin-right: 20px;
    flex-shrink: 0;
  }
  .right{
    flex: 1;
    p{
      font-size: 18px;
      color: #333;
      margin: 0;
    }
    .desc{
      font-size: 14px;
      color: #999;
      display: flex;
      align-items: center;
      margin-top: 10px;
    }
  }
}
</style>
